import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faXmark,
    faMinus,
    faCheck,
    IconDefinition,
} from '@fortawesome/free-solid-svg-icons'

const options: { value: TriStateToggleValue; icon: IconDefinition }[] = [
    { value: 'no', icon: faXmark },
    { value: 'not_selected', icon: faMinus },
    { value: 'yes', icon: faCheck },
]

export type TriStateToggleValue = 'no' | 'not_selected' | 'yes'

type Props = {
    value: TriStateToggleValue
    onChange: (value: TriStateToggleValue) => void
}

export default function TriStateToggle({
    value,
    onChange,
}: Props): React.JSX.Element {
    const getPillColor = () => {
        if (value === 'no') return 'bg-red-500'
        if (value === 'yes') return 'bg-green-500'
        return 'bg-gray-300'
    }

    const getContainerBg = () => {
        if (value === 'no') return 'bg-red-100'
        if (value === 'yes') return 'bg-green-100'
        return 'bg-gray-100'
    }

    const index = options.findIndex((o) => o.value === value)

    return (
        <div
            className={`relative flex rounded-full w-[80px] h-6 overflow-hidden transition-colors duration-300 ${getContainerBg()}`}
        >
            {/* Background pill */}
            <div
                className={`absolute inset-y-0 left-0 w-1/3 rounded-full transition-all duration-300 ${getPillColor()}`}
                style={{ left: `${index * 33.3333}%` }}
            />

            {/* Buttons */}
            {options.map((option) => (
                <button
                    key={option.value}
                    onClick={() => onChange(option.value)}
                    className={`flex-1 z-10 flex items-center justify-center text-sm transition-colors duration-300 ${
                        value === option.value ? 'text-white' : 'text-gray-400'
                    }`}
                >
                    <FontAwesomeIcon icon={option.icon} />
                </button>
            ))}
        </div>
    )
}
